import { useState } from 'react';
import { endpoints } from '@/api/endpoints';
import { useApi } from '@/api/useApi';
import { DataTable, type Column } from '@/components/DataTable';
import { StatusBadge } from '@/components/StatusBadge';
import { useLanguage } from '@/i18n/LanguageContext';
import { formatDateTime, formatNumber } from '@/i18n/format';
import type { ShipmentRow } from '@/api/types';

const LIMIT = 50;

export function ShipmentDocumentsListPage(): JSX.Element {
  const [notReady, setNotReady] = useState(false);
  const [offset, setOffset] = useState(0);
  const result = useApi(() => endpoints.shipments({ notReady, limit: LIMIT, offset }), [notReady, offset]);
  const { t, locale } = useLanguage();

  const columns: readonly Column<ShipmentRow>[] = [
    { key: 'number', header: t('shipments.colNumber'), render: (r) => r.number },
    { key: 'state', header: t('common.status'), render: (r) => <StatusBadge value={r.state} /> },
    { key: 'packages', header: t('shipments.colPackages'), render: (r) => formatNumber(r.package_count, locale), align: 'right' },
    { key: 'carrier', header: t('shipments.colCarrier'), render: (r) => r.carrier_kind ?? '—' },
    { key: 'departed', header: t('shipments.colShippedAt'), render: (r) => (r.departed_at ? formatDateTime(r.departed_at, locale) : '—') },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>{t('shipments.documentsTitle')}</h1>
      </div>
      <div className="filters">
        <label>
          <input
            type="checkbox"
            checked={notReady}
            onChange={(e) => {
              setNotReady(e.target.checked);
              setOffset(0);
            }}
          />
          {t('shipments.notReadyOnly')}
        </label>
      </div>
      <DataTable
        result={result}
        columns={columns}
        getRowHref={(r) => `/shipments/doc/${r.id}`}
        limit={LIMIT}
        offset={offset}
        onPageChange={setOffset}
        emptyTitle={t('shipments.emptyTitle')}
      />
    </div>
  );
}
